/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ([
/* 0 */
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function (global, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else { var mod; }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function () {
  "use strict";

  /*Para minificar o arquivo rode
      gulp watchJs --fn=custom --src=catalog/view/theme/lefah_new/javascript
  */

  /*ANCHOR [INÍCIO] - Inicializações globais */
  $(function () {
    loadPage();
    initStickyHeader();
    initMainCarousel();
    initPageCarousels();
    initDesktopCategoriesOverflow();
    initCategoryAriaState();
    initMobileCategoriesAccordion();
    floatingBuyButton();
    if ($('body.page-product-product').length) {
      initProductReview();
      initBuyTogether();
      initBuyTogetherPrices();
      initRelatedProductsCarousel();
      $(window).on("resize", function () {
        productFloatingPanel();
        initProductReview();
      });
    } else if ($('body.page-product-Combo-getComboPage').length) {
      initComboProductsCarousel();
    }
    productList.on('refresh', function () {
      floatingBuyButton();
    });
  });
  $(document).ready(function () {
    var isHomePage = $('body.page-common-home').length >= 1;
    var isCategoryPage = $('body.page-product-category').length >= 1;
    var isSearchPage = $('body.page-product-search').length >= 1;
    var isProductListingPage = isCategoryPage || isSearchPage;
    if (isProductListingPage) {
      if (isCategoryPage && $('.category-banner').length >= 1) {
        $('.category-banner').prependTo('#content-top');
      }
      var $toolbarShop = $('.category-content .toolbar-shop').first();
      if ($('#content-filters-v2--top').length >= 1 && $toolbarShop.length >= 1) {
        $('#content-filters-v2--top').prependTo($toolbarShop);
      }
      if (isCategoryPage && $('.category-description').length >= 1) {
        $('.category-description').appendTo('.category-information-content');
      }
      window.setTimeout(initCategoryFiltersCustom, 0);
    }
    if ($(window).width() <= 991) {
      if (isProductListingPage && $('#content-filters-v2--left').length >= 1) {
        var $mobileFilterHeader = $('#content-filters-v2--left .filterActionContainer--top').first();
        if ($mobileFilterHeader.find('.custom_filter--title').length < 1) {
          $mobileFilterHeader.prepend("<div class=\"custom_filter--title\"><h2>Filtros</h2></div>");
        }
      }
    }
    if ($('body.page-checkout-cart').length >= 1) {
      if ($('.progress-alert-content .gift_progress').length < 1) {
        $('.progress-alert-content').css('display', 'none');
      }
      if ($(window).width() >= 768) {
        $('#cart-products .product-resume:not(.gift-content)').each(function () {
          var $cartInfo = $(this).children('div');
          $cartInfo.slice(1).wrapAll("<div Class=\"cart-group_info\"></div>");
        });
      }
    }
    if (isHomePage) {
      if ($(window).width() >= 991) {
        $('.banner-grid-126 div > a').each(function () {
          var imgTitle = $(this).find('img').attr('title') || '';
          if (imgTitle) {
            $(this).append("<div class=\"overlay-grid-126\"><span class=\"overlay-text\">" + imgTitle + "</span></div>");
          }
        });
      } else {
        $('.swipper_banner_carousel_124 img').attr('fetchpriority', 'high');
      }
    }

    /*DESCRIÇÃO DO PRODUTO*/
    if ($('body.page-product-product #product').length >= 1) {
      $('#product .product-buy-button-content').appendTo('#product');
      $('#product .product-price-old').each(function () {
        $(this).text($(this).text().trim().replace(/^de\s+/i, ''));
      });
      $('#product .shipping-free-label').insertBefore('#product');
      if ($('body.page-product-product .product-description').length >= 1) {
        $(" <div class=\"custom-product_description\">\n                    <button class=\"open-custom_description\" aria-controls=\"customDescription\" aria-expanded=\"false\">\n                        <span>Descri\xE7\xE3o do produto</span>\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"8\" height=\"8\" viewBox=\"0 0 8 8\" fill=\"none\">\n                            <path d=\"M4.49023 3.50977H8V4.50977H4.49023V8H3.49023V4.50977H0V3.50977H3.49023V0H4.49023V3.50977Z\" fill=\"black\"/>\n                        </svg>\n                    </button>\n                </div>").insertAfter('#product .product-price-body');
        var customDescription = $("<aside id=\"customDescription\" class=\"custom-description-tab\"><div class=\"page-header-drawer__background\"></div></aside>");
        $("<button class=\"close-custom_description\" aria-controls=\"customDescription\" aria-expanded=\"true\">\n                    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"10\" height=\"10\" viewBox=\"0 0 10 10\" fill=\"none\">\n                        <path d=\"M10.001 0.707031L5.70703 5L10.001 9.29297L9.29395 10L5 5.70605L0.707031 10L0 9.29297L4.29297 5L0 0.707031L0.707031 0L5 4.29297L9.29395 0L10.001 0.707031Z\" fill=\"black\" fill-opacity=\"0.5\"/>\n                    </svg>\n                </button>").appendTo($('.product-description-content .heading-title'));
        $(customDescription).append($('.product-description-content'));
        $(customDescription).insertAfter('#product');
        var openDescription = $('.open-custom_description');
        var closeDescription = $('.close-custom_description');
        var descriptionTab = $('#customDescription');
        openDescription.on('click', function () {
          descriptionTab.addClass('active');
          $('body').css('overflow', 'hidden');
          $(this).attr('aria-expanded', 'true');
        });
        closeDescription.on('click', function () {
          descriptionTab.removeClass('active');
          $('body').css('overflow', '');
          openDescription.attr('aria-expanded', 'false');
        });
        $('#customDescription .page-header-drawer__background').on('click', function () {
          descriptionTab.removeClass('active');
          $('body').css('overflow', '');
          openDescription.attr('aria-expanded', 'false');
        });
      }
    }
    /*fim - DESCRIÇÃO DO PRODUTO*/
  });
  function floatingBuyButton() {
    if ($('body .product-grid').length >= 1) {
      $('.product-grid').each(function () {
        var $product = $(this);
        var $sizes = $product.find('.sizes').first();
        var $buyButton = $product.find('.product-block-hover').first();
        var $productImage = $product.find('.product-image > a').first();
        if (!$sizes.length && !$buyButton.length) return;
        var $wrapper = $("<div class=\"product-custom-info\"></div>");
        $sizes.add($buyButton).appendTo($wrapper);
        $wrapper.appendTo($productImage);
        if ($(this).find('.badge-special').length >= 1) {
          $(this).addClass('promo-badge');
        }
      });
    }
  }
  function loadPage() {
    $('body').addClass('loaded');
  }
  function initStickyHeader() {
    var header = document.querySelector('.page-header');
    if (!header) return;
    var updateHeaderState = function updateHeaderState() {
      header.classList.toggle('page-header--scrolled', window.scrollY > 0);
    };
    updateHeaderState();
    window.addEventListener('scroll', updateHeaderState, {
      passive: true
    });
  }
  function initCategoryFiltersCustom() {
    var containers = [document.getElementById('content-filters-v2--top'), document.getElementById('content-filters-v2--left')].filter(Boolean);
    containers.forEach(function (container) {
      initCategoryFilterContainer(container);
    });
  }
  function initCategoryFilterContainer(container) {
    var form = container === null || container === void 0 ? void 0 : container.querySelector('.filterForm');
    var buttons = container === null || container === void 0 ? void 0 : container.querySelector(':scope > .buttons');
    if (!container || !form || form.dataset.customFiltersReady === 'true') return;
    form.dataset.customFiltersReady = 'true';
    var selectedList = buttons === null || buttons === void 0 ? void 0 : buttons.querySelector('.items-selected');
    var clearButton = buttons === null || buttons === void 0 ? void 0 : buttons.querySelector('.clear-filters');
    var actionContainer = form.querySelector('.filterActionContainer--bottom');
    if (buttons && actionContainer) {
      form.insertBefore(buttons, actionContainer);
    }
    var getFilterInputSelector = function getFilterInputSelector() {
      return '.filters input[type="checkbox"], .filters input[type="radio"]';
    };
    var getCheckedInputs = function getCheckedInputs() {
      return Array.from(form.querySelectorAll(getFilterInputSelector())).filter(function (input) {
        return input.checked;
      });
    };
    var getCheckedSignature = function getCheckedSignature() {
      return getCheckedInputs().map(function (input) {
        return input.id || input.name || input.value;
      }).sort().join('|');
    };
    var initialCheckedSignature = getCheckedSignature();
    var getInputText = function getInputText(input) {
      var label = form.querySelector("label[for=\"".concat(input.id, "\"]"));
      var item = input.closest('li');
      return ((label === null || label === void 0 ? void 0 : label.textContent) || (item === null || item === void 0 ? void 0 : item.dataset.name) || '').replace(/\s+/g, ' ').trim();
    };
    var updateSelectedFilters = function updateSelectedFilters() {
      var checkedInputs = getCheckedInputs();
      var hasSelectedFilters = checkedInputs.length > 0;
      var hasFilterChanges = getCheckedSignature() !== initialCheckedSignature;
      var shouldShowAction = hasSelectedFilters || hasFilterChanges;
      form.classList.toggle('has-selected-filters', hasSelectedFilters);
      form.classList.toggle('has-filter-changes', hasFilterChanges);
      if (actionContainer) {
        actionContainer.hidden = !shouldShowAction;
      }
      if (clearButton) {
        clearButton.style.display = hasSelectedFilters ? '' : 'none';
      }
      if (!selectedList) return;
      selectedList.innerHTML = '';
      checkedInputs.forEach(function (input) {
        var text = getInputText(input);
        if (!text) return;
        var item = document.createElement('li');
        var button = document.createElement('button');
        var label = document.createElement('span');
        button.type = 'button';
        button.className = 'btn btn-remove-filter page-filter-selected-remove';
        button.dataset.target = input.id;
        button.setAttribute('aria-label', "Remover filtro ".concat(text));
        label.textContent = text;
        button.append(label);
        item.append(button);
        selectedList.append(item);
      });
    };
    form.querySelectorAll('.filters').forEach(function (filter, index) {
      var title = filter.querySelector(':scope > .filter-title');
      var dropdown = filter.querySelector(':scope > ul');
      if (!title || !dropdown) return;
      var dropdownId = dropdown.id || "category-filter-options-".concat(index);
      dropdown.id = dropdownId;
      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-controls', dropdownId);
      title.setAttribute('aria-expanded', 'false');
      var closeFilter = function closeFilter() {
        filter.classList.remove('is-open');
        title.setAttribute('aria-expanded', 'false');
      };
      var toggleFilter = function toggleFilter() {
        var shouldOpen = !filter.classList.contains('is-open');
        form.querySelectorAll('.filters.is-open').forEach(function (openFilter) {
          if (openFilter !== filter) {
            var openTitle = openFilter.querySelector(':scope > .filter-title');
            openFilter.classList.remove('is-open');
            openTitle === null || openTitle === void 0 || openTitle.setAttribute('aria-expanded', 'false');
          }
        });
        filter.classList.toggle('is-open', shouldOpen);
        title.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
      };
      title.addEventListener('click', toggleFilter);
      title.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        toggleFilter();
      });
      dropdown.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeFilter();
          title.focus();
        }
      });
    });
    form.addEventListener('change', function (event) {
      if (!event.target.closest('.filters')) return;
      updateSelectedFilters();
    });
    selectedList === null || selectedList === void 0 || selectedList.addEventListener('click', function (event) {
      var removeButton = event.target.closest('.page-filter-selected-remove');
      var target = removeButton === null || removeButton === void 0 ? void 0 : removeButton.dataset.target;
      var input = target ? form.querySelector("input[id=\"".concat(target, "\"]")) : null;
      if (!input) return;
      input.checked = false;
      input.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
    document.addEventListener('click', function (event) {
      if (form.contains(event.target)) return;
      form.querySelectorAll('.filters.is-open').forEach(function (filter) {
        var _filter$querySelector;
        filter.classList.remove('is-open');
        (_filter$querySelector = filter.querySelector(':scope > .filter-title')) === null || _filter$querySelector === void 0 || _filter$querySelector.setAttribute('aria-expanded', 'false');
      });
    });
    updateSelectedFilters();
  }
  function initDesktopCategoriesOverflow() {
    var desktopBreakpoint = 991;
    var menu = document.querySelector('.page-header-categories--desktop');
    if (!menu || menu.dataset.overflowReady === 'true') return;
    menu.dataset.overflowReady = 'true';
    var overflowItem = document.createElement('li');
    overflowItem.className = 'page-header-categories__items page-header-categories__items--desktop page-header-categories__items--overflow is-hidden';
    overflowItem.innerHTML = "\n        <div class=\"details page-header-categories-overflow\">\n            <div class=\"summary\">\n                <div class=\"page-header-categories__link\">\n                    <button type=\"button\" class=\"page-header-categories-overflow__button\" aria-label=\"Abrir menu de mais categorias\" aria-haspopup=\"true\" aria-expanded=\"false\" aria-controls=\"desktop-category-overflow-submenu\">\n                        <svg width=\"18\" height=\"14\" viewBox=\"0 0 18 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" aria-hidden=\"true\" focusable=\"false\">\n                            <path d=\"M1 1H17M1 7H17M1 13H17\" stroke=\"currentColor\" stroke-linecap=\"round\"/>\n                        </svg>\n                    </button>\n                </div>\n            </div>\n            <section>\n                <ul id=\"desktop-category-overflow-submenu\" class=\"page-header-categories page-header-categories--sub page-header-categories--overflow-list\" role=\"menu\"></ul>\n            </section>\n        </div>\n    ";
    menu.prepend(overflowItem);
    var overflowList = overflowItem.querySelector('.page-header-categories--overflow-list');
    var managedItems = Array.from(menu.querySelectorAll(':scope > .page-header-categories__items--desktop:not(.page-header-categories__items--department):not(.page-header-categories__items--overflow)'));
    function restoreItems() {
      var referenceItem = menu.querySelector(':scope > .page-header__info__items_mobile');
      managedItems.forEach(function (item) {
        menu.insertBefore(item, referenceItem);
      });
    }
    function setOverflowVisibility() {
      overflowItem.classList.toggle('is-hidden', overflowList.children.length === 0);
    }
    function hasOverflow() {
      var styles = window.getComputedStyle(menu);
      var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
      var visibleItems = Array.from(menu.children).filter(function (item) {
        return window.getComputedStyle(item).display !== 'none';
      });
      var itemsWidth = visibleItems.reduce(function (total, item) {
        return total + item.getBoundingClientRect().width;
      }, 0);
      var gapsWidth = Math.max(visibleItems.length - 1, 0) * gap;
      return itemsWidth + gapsWidth > menu.clientWidth + 1;
    }
    function updateCategoriesOverflow() {
      restoreItems();
      overflowList.innerHTML = '';
      setOverflowVisibility();
      if (window.innerWidth < desktopBreakpoint) return;
      var visibleItems = managedItems.filter(function (item) {
        return item.parentElement === menu;
      });
      while (visibleItems.length && hasOverflow()) {
        var item = visibleItems.pop();
        overflowList.prepend(item);
        setOverflowVisibility();
      }
    }
    var resizeFrame = null;
    function requestOverflowUpdate() {
      if (resizeFrame) {
        cancelAnimationFrame(resizeFrame);
      }
      resizeFrame = requestAnimationFrame(updateCategoriesOverflow);
    }
    window.addEventListener('resize', requestOverflowUpdate);
    window.addEventListener('load', requestOverflowUpdate);
    requestOverflowUpdate();
  }
  function initCategoryAriaState() {
    document.querySelectorAll('.page-header-menu--desktop .details').forEach(function (details) {
      if (details.dataset.ariaReady === 'true') return;
      var trigger = details.querySelector(':scope > .summary [aria-haspopup="true"][aria-controls]');
      if (!trigger) return;
      details.dataset.ariaReady = 'true';
      var setExpanded = function setExpanded(isExpanded) {
        trigger.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
      };
      details.addEventListener('mouseenter', function () {
        return setExpanded(true);
      });
      details.addEventListener('mouseleave', function () {
        if (!details.hasAttribute('open')) {
          setExpanded(false);
        }
      });
      details.addEventListener('focusin', function () {
        return setExpanded(true);
      });
      details.addEventListener('focusout', function () {
        requestAnimationFrame(function () {
          if (!details.contains(document.activeElement) && !details.hasAttribute('open')) {
            setExpanded(false);
          }
        });
      });
      details.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        setExpanded(false);
        trigger.focus();
      });
    });
  }
  function initMobileCategoriesAccordion() {
    var mobileMenu = document.getElementById('page-header-menu-mobile');
    if (!mobileMenu || mobileMenu.dataset.accordionReady === 'true') return;
    mobileMenu.dataset.accordionReady = 'true';
    mobileMenu.addEventListener('click', function (event) {
      var toggle = event.target.closest('.js-mobile-category-toggle');
      if (!toggle || !mobileMenu.contains(toggle)) return;
      var item = toggle.closest('.page-header-categories__items--mobile');
      var subcategories = item === null || item === void 0 ? void 0 : item.querySelector(':scope > .page-header-categories--sub, :scope > .page-header-categories--sub-sub');
      if (!item || !subcategories) return;
      event.preventDefault();
      var isOpen = item.classList.contains('is-open');
      var siblingItems = Array.from(item.parentElement.children).filter(function (sibling) {
        return sibling !== item && sibling.classList.contains('page-header-categories__items--mobile');
      });
      siblingItems.forEach(function (sibling) {
        sibling.classList.remove('is-open');
        sibling.querySelectorAll('[aria-expanded="true"]').forEach(function (siblingToggle) {
          siblingToggle.setAttribute('aria-expanded', 'false');
        });
        sibling.querySelectorAll('.page-header-categories__items--mobile.is-open').forEach(function (childItem) {
          childItem.classList.remove('is-open');
        });
      });
      item.classList.toggle('is-open', !isOpen);
      toggle.setAttribute('aria-expanded', !isOpen ? 'true' : 'false');
      if (isOpen) {
        item.querySelectorAll('.page-header-categories__items--mobile.is-open').forEach(function (childItem) {
          childItem.classList.remove('is-open');
        });
        item.querySelectorAll('[aria-expanded="true"]').forEach(function (childToggle) {
          if (childToggle !== toggle) {
            childToggle.setAttribute('aria-expanded', 'false');
          }
        });
      }
    });
  }

  /*Construir carrossel Swiper*/
  function initPageCarousels() {
    document.querySelectorAll('[data-swiper="true"]').forEach(function (el) {
      var totalSlides = el.querySelectorAll('.swiper-slide').length;
      var loop = el.dataset.loop === 'true';
      var spaceBetween = Number(el.dataset.spaceBetween || '8');
      var slidesPerView = Number(el.dataset.slidesPerView || '4');
      var autoplay = el.dataset.autoplay === 'true';
      var autoplayDelay = Number(el.dataset.autoplayDelay || '3000');
      var disableOnInteraction = el.dataset.autoplayDisableInteraction !== 'false';
      var breakpoints = {};
      try {
        if (el.dataset.breakpoints) {
          breakpoints = JSON.parse(el.dataset.breakpoints);
          for (var key in breakpoints) {
            if (breakpoints[key].slidesPerView) {
              breakpoints[key].slidesPerView = Number(breakpoints[key].slidesPerView);
              breakpoints[key].spaceBetween = Number(breakpoints[key].spaceBetween || spaceBetween);
              breakpoints[key].loop = totalSlides > breakpoints[key].slidesPerView ? loop : false;
            }
          }
        }
      } catch (e) {
        console.warn('Erro ao ler data-breakpoints:', e);
      }
      var nextEl = el.dataset.navigationNextEl ? el.querySelector(el.dataset.navigationNextEl) : el.querySelector('.swiper-button-next');
      var prevEl = el.dataset.navigationPrevEl ? el.querySelector(el.dataset.navigationPrevEl) : el.querySelector('.swiper-button-prev');
      var updateNavigationOpacity = function updateNavigationOpacity(swiper) {
        if (!prevEl || !nextEl || loop) return;
        prevEl.style.opacity = swiper.isBeginning ? '.2' : '1';
        nextEl.style.opacity = swiper.isEnd ? '.2' : '1';
      };
      var swiper = new Swiper(el, {
        loop: loop,
        spaceBetween: spaceBetween,
        slidesPerView: slidesPerView,
        breakpoints: breakpoints,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl
        },
        autoplay: autoplay ? {
          delay: autoplayDelay,
          disableOnInteraction: disableOnInteraction
        } : false,
        on: {
          init: updateNavigationOpacity,
          slideChange: updateNavigationOpacity,
          resize: updateNavigationOpacity,
          update: updateNavigationOpacity
        }
      });
      updateNavigationOpacity(swiper);
    });
  }
  /*fim - Construir carrossel Swiper*/

  /*[Aux] - Agrupa título, avaliação e modelo em uma section-title (desktop) */
  function initMainCarousel() {
    var mainCarousel = document.querySelector('.product .productMainCarousel');
    if (mainCarousel !== null && mainCarousel !== void 0 && mainCarousel.swiper) {
      mainCarousel.swiper.destroy(true, true);
    }
    new Swiper('.product .productMainCarousel', {
      spaceBetween: 8,
      freeMode: true,
      lazy: true,
      slidesOffsetAfter: 431,
      breakpoints: {
        0: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 2.5
        },
        1280: {
          slidesPerView: 3.5
        }
      },
      navigation: {
        nextEl: '.product .productMainCarousel .swiper-button-next',
        prevEl: '.product .productMainCarousel .swiper-button-prev'
      },
      pagination: {
        el: '.productMainCarousel .swiper-pagination',
        clickable: true
      }
    });
  }

  /*ANCHOR [INÍCIO] - Avaliações do produto */
  /*[1] - Reposicionar links e botões de navegação no desktop */
  $('#review-links').appendTo('#reviews-title .heading-title');
  if ($(window).width() > 1024) {
    $("<div class=\"reviews-buttons\">\n        <div class=\"swiper-button-prev\"></div>\n        <div class=\"swiper-button-next\"></div>\n    </div>").insertAfter('#review-links');
  }
  function initProductReview() {
    /*[2] - Destruir swiper existente e recriar com novas configurações */
    var reviewsElement = document.querySelector('.reviews-list');
    if (reviewsElement !== null && reviewsElement !== void 0 && reviewsElement.swiper) {
      reviewsElement.swiper.destroy(true, true);
    }

    /*[3] - Garantindo nome no formato padrão */
    $('#review .review-author').each(function () {
      var $el = $(this);
      var text = $el.text().trim();
      if (text === text.toUpperCase()) {
        var capitalized = text.toLowerCase().replace(/\b\w/g, function (_char) {
          return _char.toUpperCase();
        });
        $el.text(capitalized);
      }
    });
    new Swiper('.reviews-list', {
      spaceBetween: 0,
      lazy: true,
      centeredSlides: false,
      loop: false,
      freeMode: false,
      initialSlide: 0,
      breakpoints: {
        0: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 2.5
        },
        1024: {
          slidesPerView: 3.5
        }
      },
      navigation: {
        nextEl: '.reviews-buttons .swiper-button-next',
        prevEl: '.reviews-buttons .swiper-button-prev'
      }
    });
  }
  function initBuyTogether() {
    /*[1] - Transformar lista em swiper */
    buildBuyTogetherSwiper();

    /*[2] - Remover classes e estrutura legada desnecessária */
    cleanBuyTogetherLayout();

    /*[3] - Adicionar nome do produto principal ao resumo de preço */
    prependMainProductToBuyTogether();

    /*[4] - Remover texto "ou" dos preços do compre junto */
    cleanBuyTogetherPriceText();

    /*[5] - Mover navegação para dentro do heading no desktop */
    if ($(window).width() > 1023) {
      $('.buy-together-content .swiper-navigation').appendTo('.buy-together-content .heading-title');
    }

    /*[6] - Bloquear/Desbloquear botão do compre junto*/
    toggleBuyTogetherButton();
  }

  /*[Aux] - Converte a lista de itens do compre junto em swiper */
  function buildBuyTogetherSwiper() {
    $('.buy-together-items-content').addClass('swiper').wrapInner('<div class="swiper-wrapper"></div>');
    $('.buy-together').addClass('swiper-slide');
    $('.buy-together-items-content').after("\n        <div class=\"swiper-navigation\">\n            <div class=\"swiper-button-prev\"></div>\n            <div class=\"swiper-button-next\"></div>\n        </div>\n    ");
    new Swiper('.buy-together-items-content', {
      spaceBetween: 8,
      breakpoints: {
        0: {
          slidesPerView: 1.2
        },
        768: {
          slidesPerView: 2.5
        },
        991: {
          slidesPerView: 2
        }
      },
      navigation: {
        nextEl: '.buy-together-content .swiper-button-next',
        prevEl: '.buy-together-content .swiper-button-prev'
      },
      loop: false
    });
  }

  /*[Aux] - Bloquear/Desbloquear botão do compre junto*/
  function toggleBuyTogetherButton() {
    var checkboxActive = $('.page-product-product .buy-together .buy-together-check.text-success').length > 0;
    var $wrapper = $('.buy-btn-wrapper');
    var $btn = $('.page-product-product #buy-together-button');
    $btn.toggleClass('disabled', !checkboxActive);
    $wrapper.toggleClass('disabled', !checkboxActive);
    if (checkboxActive) {
      $('.custom-buyTogether-error').removeClass('on');
    }
  }
  $(document).ready(function () {
    $('#buy-together-button').wrap('<div class="buy-btn-wrapper"></div>');
    $("<div class=\"custom-buyTogether-error\">\n            <span>Selecione uma op\xE7\xE3o do produto</span>\n        </div>\n    ").insertAfter('.buy-btn-wrapper');
    toggleBuyTogetherButton();
  });
  $(document).on('click', '.buy-btn-wrapper.disabled', function () {
    $('.page-product-product .buy-together .options-list select').addClass('select-error');
    $('.custom-buyTogether-error').addClass('on');
  });
  $(document).on('change', '.page-product-product .buy-together .options-list select', function () {
    $('.page-product-product .buy-together .options-list select').removeClass('select-error');
    setTimeout(toggleBuyTogetherButton, 50);
  });

  /*[Aux] - Remove classes de grid legadas do compre junto */
  function cleanBuyTogetherLayout() {
    $('.buy-together-container .buy-together-nav').remove();
    $('.buy-together-container .buy-together-main-product').removeClass('mr-30 col-md-3');
    $('.buy-together-container .buy-together-items').removeClass('col-md-6');
    $('.buy-together-container .buy-together-buy-btn').removeClass('col-md-3');
  }

  /*[Aux] - Adiciona o título do produto principal ao bloco de preço */
  function prependMainProductToBuyTogether() {
    $('.page-product-product .product-title.title').clone().prependTo($('.buy-together-main-product .product-buy-together-price'));
    $(document).ready(function () {
      if ($('.buy-together-buy-btn .price').length >= 1) {
        var getPriceEl = function getPriceEl() {
          return $('.buy-together-buy-btn .price b');
        };
        $('.buy-together-btn-content').addClass('show_total');
        var customBuytogetherTotal = $("\n                <div class=\"custom_buy-together--total\">\n                <span>Compre junto por</span>\n                </div>\n            ");
        getPriceEl().first().clone().appendTo(customBuytogetherTotal);
        $('.buy-together-btn-content').prepend(customBuytogetherTotal);
        var container = document.querySelector('.buy-together-buy-btn .price');
        if (!container) return;
        var timeout;
        var observer = new MutationObserver(function () {
          clearTimeout(timeout);
          timeout = setTimeout(function () {
            var newPrice = getPriceEl().html();
            $('.custom_buy-together--total b').html(newPrice);
          }, 200);
        });
        observer.observe(container, {
          childList: true,
          subtree: true
        });
      }
    });
  }

  /*[Aux] - Remove o texto "ou" dos preços de desconto do compre junto */
  function cleanBuyTogetherPriceText() {
    var removeOu = function removeOu(el) {
      return $(el).text($(el).text().replace('ou', ''));
    };
    removeOu('.buy-together-main-product .product-price-discount');
    $('.buy-together-items .owl-item').each(function () {
      removeOu($(this).find('.product-price .product-price-discount'));
    });
  }

  /*ANCHOR [INÍCIO] - Preços do compre junto (limpeza de labels) */
  function initBuyTogetherPrices() {
    /*[1] - Remover ":" do preço antigo */
    $('.buy-together-container .product-price-old').each(function () {
      $(this).text($(this).text().trim().replace(/^de\s*:?\s*/i, ''));
    });

    /*[2] - Remover "Por" do preço novo */
    $('.buy-together-container .product-price-new').each(function () {
      $(this).text($(this).text().replace(/Por\s*/g, '').trim());
    });

    /*[3] - Reposicionar o bloco do compre junto após as avaliações */
    $('.product-content .buy-together-content').insertAfter('.product-informations .products-review-content');
  }
  function productFloatingPanel() {
    var floatingPanel = $('.floating-panel');
    var info = floatingPanel.find('.floating-panel__info');
    var price = floatingPanel.find('.floating-panel__price');
    var mainPrice = floatingPanel.find('.floating-panel__main-price');
    var options = floatingPanel.find('.floating-panel__options');
    var screenWidth = window.innerWidth;
    if (screenWidth < 1024) {
      price.appendTo(mainPrice);
    } else {
      price.appendTo(info);
    }
    options.appendTo(info);
  }

  /*[Aux] - Cria o carrossel de produtos relacionados */
  function initRelatedProductsCarousel() {
    if (!$('body.page-product-product').length && !$('body.page-product-Combo-getComboPage').length) return;
    var swiperNavigation = $('<div class="swiper-navigation"></div>').appendTo('.products-related-content .heading-title');
    $('.products-related-content .swiper-button-prev').appendTo(swiperNavigation);
    $('.products-related-content .swiper-button-next').appendTo(swiperNavigation);
    var relatedElement = document.querySelector('#products-related');
    if (relatedElement !== null && relatedElement !== void 0 && relatedElement.swiper) {
      relatedElement.swiper.destroy(true, true);
    }
    new Swiper('#products-related', {
      spaceBetween: 8,
      freeMode: true,
      lazy: true,
      breakpoints: {
        0: {
          slidesPerView: 1.25
        },
        768: {
          slidesPerView: 3
        },
        991: {
          slidesPerView: 4
        },
        1024: {
          slidesPerView: 5
        }
      },
      navigation: {
        nextEl: '.products-related-content .swiper-button-next',
        prevEl: '.products-related-content .swiper-button-prev'
      },
      pagination: {
        el: '.products-related-content .swiper-pagination',
        clickable: true
      }
    });
    $(relatedElement).addClass('updated');
  }
  function initComboProductsCarousel() {
    var comboElement = document.querySelector('.combo-swiper');
    if (comboElement !== null && comboElement !== void 0 && comboElement.swiper) {
      comboElement.swiper.destroy(true, true);
    }
    var comboProduct = $('.combo-tab .combo-tab__top-left img');
    comboProduct.each(function () {
      var src = $(this).attr('src');
      if (src) {
        var novaUrl = src.replace(/\/fit-in\/[^/]+\/filters:[^/]+\//, '/');
        $(this).attr('src', novaUrl);
      }
    });
    $('.combo-description--desktop').insertAfter('.combo .combo-middle');
    new Swiper('.combo-swiper', {
      spaceBetween: 8,
      freeMode: true,
      lazy: true,
      slidesOffsetAfter: 531,
      breakpoints: {
        0: {
          slidesPerView: 1
        },
        768: {
          slidesPerView: 2
        },
        992: {
          slidesPerView: 2.5
        },
        1280: {
          slidesPerView: 3.5
        }
      },
      navigation: {
        nextEl: '.combo-swiper .swiper-button-next',
        prevEl: '.combo-swiper .swiper-button-prev'
      },
      pagination: {
        el: '.combo-swiper .swiper-pagination',
        clickable: true
      }
    });
  }

  /*SEARCH*/
  $.ajax({
    url: 'index.php?route=common/most_searched',
    type: 'GET',
    dataType: 'json',
    success: function success(response) {
      var html = '';
      var limit = $(window).width() <= 768 ? 3 : response.length;
      var items = response.slice(0, limit);
      $(items).each(function (index, item) {
        html += "<span class=\"most-searched-item\" data-item=\"".concat(item.keyword, "\">").concat(item.keyword, "</span>");
      });
      $(".most-searched-content").html("".concat(html));
    },
    error: function error(xhr, status, _error) {
      console.error(_error);
    }
  });
  $(document).ready(function () {
    var debounceTimer;
    $('.ac_input').on('focus', function () {
      $('#page-header-search, #page-header-search__mobile').addClass('search-active');
    });
    $('#search .close-search').on('click', function () {
      $('#page-header-search, #page-header-search__mobile').removeClass('search-active');
    });
    $('#search .ac_input').on('input', function () {
      var query = $(this).val().trim();
      var spinner = "<svg class=\"loading-search\" viewBox=\"25 25 50 50\" aria-hidden=\"true\" focusable=\"false\">\n                        <circle r=\"20\" cy=\"50\" cx=\"50\"></circle>\n                    </svg>";
      $(".pre-search").attr('aria-busy', 'true').html(spinner);
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        if (query.length > 2) {
          newSearch(query);
          $('.content-pre-search__title p').html('Resultados da busca');
        } else {
          $(".pre-search").empty();
          newSearch('falésias');
        }
      }, 400);
    });
    newSearch('falésias');
    function newSearch(search) {
      $.get("index.php?route=common/autocomplete&q=".concat(search, "&limit=12"), function (data) {
        $(".pre-search").attr('aria-busy', 'false');
        var rows = data.trim().split("\n").filter(function (r) {
          return r;
        });
        var html = "";
        var isDesktop = window.innerWidth >= 1200;
        var totalItems = rows.length;
        if (totalItems === 0) {
          $(".pre-search").html('<div class="empty-search">Nenhum resultado encontrado</div>');
          return;
        }
        rows.forEach(function (row) {
          var t = row.split("|");
          html += "\n                    <li style=\"display:flex; cursor:pointer;\" onclick=\"addMostSearched('".concat(t[0], "','").concat(t[4], "')\">\n                        <div>\n                            <img src=\"").concat(t[1], "\" style=\"width:50px; height:50px; object-fit:cover;\" />\n                        </div>\n                        <div class=\"item-search-body\" style=\"flex:1;\">\n                            <p class=\"name\">").concat(t[0]).concat(t[3], "</p>\n                            <div class=\"value\">").concat(t[2], "</div>\n                        </div>\n                    </li>\n                ");
        });
        if (totalItems >= 3) {
          $(".pre-search").html("\n                    <div class=\"swiper\"\n                        data-swiper=\"true\"\n                        data-space-between=\"8\"\n                        data-slides-per-view=\"2\"\n                        data-breakpoints='{\"428\":{\"slidesPerView\":2.5},\"515\":{\"slidesPerView\":3},\"640\":{\"slidesPerView\":3.5},\"685\":{\"slidesPerView\":4},\"777\":{\"slidesPerView\":4.5},\"846\":{\"slidesPerView\":5},\"991\":{\"slidesPerView\":7}}'\n                        data-navigation-prev-el=\".custom-prev\" data-navigation-next-el=\".custom-next\">\n                        <ul class=\"ac_results swiper-wrapper\">\n                            ".concat(html.replaceAll('<li', '<li class="swiper-slide"'), "\n                        </ul>\n                        <div class=\"custom-swiper__buttons\">\n                            <button class=\"custom-prev\">\n                                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"10\" viewBox=\"0 0 13 10\" fill=\"none\">\n                                    <path d=\"M-4.37029e-07 5L0.353515 4.64649L4.99902 6.88027e-07L5.70605 0.707032L1.91406 4.5L12.8691 4.5L12.8691 5.5L1.91406 5.5L5.70605 9.29199L4.99902 9.99902L-4.37029e-07 5Z\" fill=\"black\"/>\n                                </svg>\n                            </button>\n                            <button class=\"custom-next\">\n                                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"10\" viewBox=\"0 0 13 10\" fill=\"none\">\n                                    <path d=\"M12.8691 4.99902L12.5156 5.35254L7.87012 9.99902L7.16309 9.29199L10.9551 5.49902H0V4.49902H10.9551L7.16309 0.707031L7.87012 0L12.8691 4.99902Z\" fill=\"black\"/>\n                                </svg>\n                            </button>\n                        </div>\n                    </div>\n                "));
          initPageCarousels();
        } else {
          $(".pre-search").html("\n                    <ul class=\"ac_results no-swiper\">\n                        ".concat(html, "\n                    </ul>\n                "));
        }
      });
    }
    function newSerchEvent() {
      var $input = $('#search-input, #search .ac_input').first();
      var baseUrl = $input.data('url');
      var searchValue = $input.val().trim();
      if (!baseUrl || !searchValue) return;
      var finalUrl = baseUrl + '?search=' + encodeURIComponent(searchValue);
      location = finalUrl;
    }
    $(document).on('keydown', '#search-input, #search .ac_input', function (event) {
      if (event.key === 'Enter' || event.which === 13) {
        event.preventDefault();
        newSerchEvent();
      }
    });
    $(document).on('click', '#search .btn-search, .new-btn-search', function (event) {
      event.preventDefault();
      newSerchEvent();
    });
    $(document).on('click', '.most-searched-item', function () {
      var spinner = "<svg class=\"loading-search\" viewBox=\"25 25 50 50\">\n                        <circle r=\"20\" cy=\"50\" cx=\"50\"></circle>\n                    </svg>";
      $(".pre-search").html(spinner);
      var item = $(this).data('item');
      $('#search-input, #new-component-search').first().val(item);
      newSearch(item);
    });
  });
  /*FIM - SEARCH*/
});

/***/ })
/******/ 	]);
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module is referenced by other modules so it can't be inlined
/******/ 	var __webpack_exports__ = __webpack_require__(0);
/******/ 	
/******/ })()
;